module.exports = __webpack_public_path__ + "img/heel-off-shoe.6bda9fb7.svg";